import { render, staticRenderFns } from "./Tagging.vue?vue&type=template&id=13fe7ec8&"
import script from "./Tagging.vue?vue&type=script&lang=ts&"
export * from "./Tagging.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports